export const AXIOS_TIMEOUT_CODE = "ECONNABORTED";
export const AXIOS_TIMEOUT_ERROR_MESSAGE = "AXIOS_TIMEOUT_ERROR_MESSAGE";
export const LIMIT_ITEM_PER_LOAD = 20;

export const API_APP_ERROR_CODE = Object.freeze({
  CANCEL: "CANCEL",
});

export const API_RESULT_CODE = {
  OK: "OK",
  ERROR: "ERROR",
};
export const MAX_TIME_WAIT = 1000 * 20;

export enum PATH_API {
  INSPECTION_GROUP = "/v1/inspections/groups",
  INSPECTION_CONTENT = "/v1/inspections/contents",
  INSPECTION_ITEM = "/v1/inspections/items",
  INSPECTION_ITEM_RESULT = "/v1/inspections/items/results",
  INSPECTION_TYPE = "/v1/inspections/types",
  INSPECTION_PIN = "/v1/inspections/pins",
  INSPECTION_PIN_CONTENT = "/v1/inspections/pins/content",
  INSPECTION_PIN_GROUP = "/v1/inspections/pins/group",
  INSPECTION_INSTANCE = "/v1/inspections/instances",
  INSPECTION_TARGET = "/v1/inspections/targets",
  SUB_ITEMS = "/v1/document-items/sub-items",
  BIM_FILES = "/v1/bims/files",
  USER_SETTINGS = "/v1/users/settings",
  BIM_VIEW = "/v1/bims/views",
  DOCUMENT_FORMAT = "/v1/documents/formats",
  DOCUMENT_PAGE_COMPONENT = "/v1/documents/page-components",
  DOCUMENT_PAGE_LAYOUT = "/v1/documents/page-layouts",
  DOCUMENT_PIN_COMPONENT = "/v1/documents/pin-components",
  DOCUMENT_PIN_LAYOUT = "/v1/documents/pin-layouts",
  DOCUMENT = "/v1/documents",
  AREA = "/v1/areas",
  BLACKBOARD = "/v1/blackboards",
  BLACKBOARD_TEMPLATE = "/v1/blackboard-templates",
  CACHE = "/v1/caches",
  DATA_LOG = "/v1/data-logs",
  DOCUMENT_CATEGORY = "/v1/document-categories",
  DOCUMENT_COMPONENT = "/v1/document-components",
  DOCUMENT_GROUP = "/v1/document-groups",
  DOCUMENT_ITEM = "/v1/document-items",
  DOCUMENT_KEYNOTE = "/v1/document-keynotes",
  DOCUMENT_TASK = "/v1/document-tasks",
  DOCUMENT_TEMPLATE = "/v1/document-templates",
  FAMILY = "/v1/families",
  FILTER = "/v1/filters",
  FORGE = "/v1/aps/projects",
  PARTNER_COMPANY = "/v1/partner-companies",
  PROJECT = "/v1/projects",
  S3 = "/v1/s3",
  TASK = "/v1/tasks",
  TASK_COMMENT = "/v1/task-comments",
  TASK_SHEET_TEMPLATE = "/v1/task-sheet-templates",
  TASK_TYPE = "/v1/task-types",
  USER = "/v1/users",
  AUTH = "/v1/auth",
  BLACKBOARD_FORMAT = "/v1/blackboards/formats",
  BLACKBOARD_FRAME = "/v1/blackboards/frames",
  KEYPLAN_LAYOUT = "/v1/documents/keyplan-layouts",
  KEYPLAN_FRAME = "/v1/documents/keyplan-frames",
  GENERATED_DATA = "/v1/bims/generated-data",
  IMAGES = "/images",
  PIN_CONTENT_IMAGE = "/v1/inspections/pins/content/images",
}

export const LIST_PATH_API_DETAIL = [
  `${PATH_API.BIM_FILES}/data-generate`,
  `${PATH_API.BIM_FILES}/:id`,
  `${PATH_API.DOCUMENT}/:id`,
  `${PATH_API.DOCUMENT_FORMAT}/:id`,
  `${PATH_API.DOCUMENT_PAGE_LAYOUT}/:id`,
  `${PATH_API.DOCUMENT_PIN_LAYOUT}/:id`,
  `${PATH_API.INSPECTION_GROUP}/:id`,
  `${PATH_API.INSPECTION_TYPE}/:id`,
  `${PATH_API.INSPECTION_PIN}/:id`,
  `${PATH_API.AUTH}/current-user`,
  `${PATH_API.AUTH}/aps-token`,
  `${PATH_API.AUTH}/token`,
  `${PATH_API.BLACKBOARD_TEMPLATE}/:id`,
  `${PATH_API.TASK_TYPE}/count-items/`,
  `${PATH_API.DOCUMENT_TASK}/:id`,
  `${PATH_API.DOCUMENT_TEMPLATE}/:id`,
  `${PATH_API.FORGE}/:id`,
  `${PATH_API.FORGE}/:id/bims/first`,
  `${PATH_API.FORGE}/:id/bims/version/:versionId/derivatives`,
  `${PATH_API.FORGE}/:id/bims/version/:versionId/aec`,
  `${PATH_API.PROJECT}/:id`,
  `${PATH_API.S3}/forge-data`,
  `${PATH_API.TASK}/:id`,
  `${PATH_API.TASK_SHEET_TEMPLATE}/:id`,
  `${PATH_API.TASK_TYPE}/:id`,
  `${PATH_API.USER}/profiles`,
  `${PATH_API.KEYPLAN_LAYOUT}/:id`,
  `${PATH_API.GENERATED_DATA}/data-type`,
  `${PATH_API.IMAGES}`,
];
